import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";

export default function createEmotionCache(direction = "ltr") {
  const isRtl = direction === "rtl";

  return createCache({
    key: isRtl ? "mui-rtl" : "mui-ltr",
    stylisPlugins: isRtl ? [prefixer, rtlPlugin] : [prefixer],
  });
}
